import empty from "../parts/void.svg";

import baseCommon from "../parts/base/common.svg";
import base1f921 from "../parts/base/1f921.svg";
import base1f922 from "../parts/base/1f922.svg";
import base1f976 from "../parts/base/1f976.svg";
import base1f975 from "../parts/base/1f975.svg";
import base1f621 from "../parts/base/1f621.svg";

import baseCommonCat from "../parts/base/common_cat.svg";
import base1f435 from "../parts/base/1f435.svg";
import base1f437 from "../parts/base/1f437.svg";
import base1f47d from "../parts/base/1f47d.svg";
import base1f608 from "../parts/base/1f608.svg";

import base1f628 from "../parts/base/1f628.svg";
import base1f631 from "../parts/base/1f631.svg";
import base1f631Flat from "../parts/base/1f631_flat.svg";
import base1f640 from "../parts/base/1f640.svg";

import base1f920 from "../parts/base/1f920.svg";
import base1f973 from "../parts/base/1f973.svg";
import base1f92f from "../parts/base/1f92f.svg";

import base1f345 from "../parts/base/1f345.svg";
import base1f383 from "../parts/base/1f383.svg";

import base1f4a9 from "../parts/base/1f4a9.svg";

// NG
// import base1f425 from '../parts/base/1f425.svg';
// import base1f98d from '../parts/base/1f98d.svg';
// import base1f428 from '../parts/base/1f428.svg';
// import base1f431 from '../parts/base/1f431.svg';

// duplicated
// import base1f30d from '../parts/base/1f30d.svg';
// import base1f30e from '../parts/base/1f30e.svg';
// import base1f30f from '../parts/base/1f30f.svg';
// import base1f311 from '../parts/base/1f311.svg';
// import base1f312 from '../parts/base/1f312.svg';
// import base1f313 from '../parts/base/1f313.svg';
// import base1f314 from '../parts/base/1f314.svg';
// import base1f315 from '../parts/base/1f315.svg';
// import base1f316 from '../parts/base/1f316.svg';
// import base1f317 from '../parts/base/1f317.svg';
// import base1f318 from '../parts/base/1f318.svg';
// import base1f36a from '../parts/base/1f36a.svg';
// import base1f630 from '../parts/base/1f630.svg';
// import base1f92c from '../parts/base/1f92c.svg';

import eyes1f425 from "../parts/eyes/1f425.svg";
import eyes1f921 from "../parts/eyes/1f921.svg";
import eyes1f600 from "../parts/eyes/1f600.svg";
import eyes1f913 from "../parts/eyes/1f913.svg";
import eyes1f61b from "../parts/eyes/1f61b.svg";
import eyes1f617 from "../parts/eyes/1f617.svg";
import eyes1f610 from "../parts/eyes/1f610.svg";
import eyes1f925 from "../parts/eyes/1f925.svg";
import eyes1f920 from "../parts/eyes/1f920.svg";
import eyes1f92f from "../parts/eyes/1f92f.svg";
import eyes1f643 from "../parts/mouths/1f643.svg";
import eyes1f603 from "../parts/eyes/1f603.svg";

import eyes1f31a from "../parts/eyes/1f31a.svg";
import eyes1f63a from "../parts/eyes/1f63a.svg";
import eyes1f435 from "../parts/eyes/1f435.svg";
import eyes1f437 from "../parts/eyes/1f437.svg";
import eyes1f431 from "../parts/eyes/1f431.svg";
import eyes1f428 from "../parts/eyes/1f428.svg";

import eyes1f917 from "../parts/eyes/1f917.svg";
import eyes1f92d from "../parts/eyes/1f92d.svg";
import eyes1f915 from "../parts/eyes/1f915.svg";
import eyes1f604 from "../parts/eyes/1f604.svg";
import eyes1f613 from "../parts/eyes/1f613.svg";
import eyes1f61e from "../parts/eyes/1f61e.svg";

import eyes1f970 from "../parts/eyes/1f970.svg";
import eyes1f601 from "../parts/eyes/1f601.svg";
import eyes1f607 from "../parts/eyes/1f607.svg";

import eyes1f60a from "../parts/eyes/1f60a.svg";
import eyes1f60b from "../parts/eyes/1f60b.svg";

import eyes1f971 from "../parts/eyes/1f971.svg";
import eyes1f637 from "../parts/eyes/1f637.svg";
import eyes1f973 from "../parts/eyes/1f973.svg";

import eyes1f611 from "../parts/eyes/1f611.svg";
import eyes1f634 from "../parts/eyes/1f634.svg";

import eyes1f927 from "../parts/eyes/1f927.svg";
import eyes1f606 from "../parts/eyes/1f606.svg";
import eyes1f92e from "../parts/eyes/1f92e.svg";
import eyes1f923 from "../parts/eyes/1f923.svg";

import eyes1f922 from "../parts/eyes/1f922.svg";
import eyes1f98d from "../parts/eyes/1f98d.svg";
import eyes1f383 from "../parts/eyes/1f383.svg";
import eyes1f644 from "../parts/eyes/1f644.svg";
import eyes1f97a from "../parts/eyes/1f97a.svg";
import eyes1f4a9 from "../parts/eyes/1f4a9.svg";
import eyes1f47d from "../parts/eyes/1f47d.svg";
import eyes1f640 from "../parts/eyes/1f640.svg";
import eyes1f631 from "../parts/eyes/1f631.svg";
import eyes1f61c from "../parts/eyes/1f61c.svg";
import eyes1f92a from "../parts/eyes/1f92a.svg";
import eyes1f911 from "../parts/eyes/1f911.svg";
import eyes1f60d from "../parts/eyes/1f60d.svg";
import eyes1f63b from "../parts/eyes/1f63b.svg";
import eyes1f929 from "../parts/eyes/1f929.svg";
import eyes1f60e from "../parts/eyes/1f60e.svg";

import eyes1f92b from "../parts/eyes/1f92b.svg";
import eyes1f62f from "../parts/eyes/1f62f.svg";
import eyes1f632 from "../parts/eyes/1f632.svg";
import eyes1f627 from "../parts/eyes/1f627.svg";
import eyes1f622 from "../parts/eyes/1f622.svg";
import eyes1f63f from "../parts/eyes/1f63f.svg";

import eyes1f924 from "../parts/eyes/1f924.svg";
import eyes1f602 from "../parts/eyes/1f602.svg";
import eyes1f61a from "../parts/eyes/1f61a.svg";
import eyes1f638 from "../parts/eyes/1f638.svg";

import eyes1f974 from "../parts/eyes/1f974.svg";
import eyes1f630 from "../parts/eyes/1f630.svg";
import eyes1f61f from "../parts/eyes/1f61f.svg";
import eyes1f912 from "../parts/eyes/1f912.svg";
import eyes1f625 from "../parts/eyes/1f625.svg";
import eyes1f975 from "../parts/eyes/1f975.svg";
import eyes1f976 from "../parts/eyes/1f976.svg";

import eyes1f629 from "../parts/eyes/1f629.svg";
import eyes1f614 from "../parts/eyes/1f614.svg";

import eyes1f60c from "../parts/eyes/1f60c.svg";
import eyes1f62a from "../parts/eyes/1f62a.svg";
import eyes263a from "../parts/eyes/263a.svg";

import eyes1f62b from "../parts/eyes/1f62b.svg";
import eyes1f623 from "../parts/eyes/1f623.svg";
import eyes1f616 from "../parts/eyes/1f616.svg";

import eyes1f60f from "../parts/eyes/1f60f.svg";
import eyes1f612 from "../parts/eyes/1f612.svg";
import eyes1f624 from "../parts/eyes/1f624.svg";

import eyes1f620 from "../parts/eyes/1f620.svg";
import eyes1f63c from "../parts/eyes/1f63c.svg";
import eyes1f63e from "../parts/eyes/1f63e.svg";
import eyes1f92c from "../parts/eyes/1f92c.svg";
import eyes1f621 from "../parts/eyes/1f621.svg";
import eyes1f47f from "../parts/eyes/1f47f.svg";
import eyes1f608 from "../parts/eyes/1f608.svg";

import eyes1f618 from "../parts/eyes/1f618.svg";
import eyes1f609 from "../parts/eyes/1f609.svg";

import eyes1f928 from "../parts/eyes/1f928.svg";
import eyes1f914 from "../parts/eyes/1f914.svg";

import eyes1f633 from "../parts/eyes/1f633.svg";
import eyes1f635 from "../parts/eyes/1f635.svg";
import eyes1f62d from "../parts/eyes/1f62d.svg";
import eyes1f9d0 from "../parts/eyes/1f9d0.svg";

// duplicated
// import eyes1f615 from '../parts/eyes/1f615.svg';
// import eyes1f626 from '../parts/eyes/1f626.svg';
// import eyes1f62c from '../parts/eyes/1f62c.svg';
// import eyes1f910 from '../parts/eyes/1f910.svg';
// import eyes1f636 from '../parts/eyes/1f636.svg';
// import eyes2639 from '../parts/eyes/2639.svg';
// import eyes1f62e from '../parts/eyes/1f62e.svg';
// import eyes1f641 from '../parts/eyes/1f641.svg';
// import eyes1f642 from '../parts/eyes/1f642.svg';
// import eyes1f61d from '../parts/eyes/1f61d.svg';
// import eyes1f619 from '../parts/eyes/1f619.svg';
// import eyes1f605 from '../parts/eyes/1f605.svg';
// import eyes1f628 from '../parts/eyes/1f628.svg';
// import eyes1f639 from '../parts/eyes/1f639.svg';
// import eyes1f63d from '../parts/eyes/1f63d.svg';

import mouth1f917 from "../parts/mouths/1f917.svg";
import mouth1f970 from "../parts/mouths/1f970.svg";
import mouth1f60a from "../parts/mouths/1f60a.svg";
import mouth1f607 from "../parts/mouths/1f607.svg";
import mouth1f60e from "../parts/mouths/1f60e.svg";
import mouth1f642 from "../parts/mouths/1f642.svg";
import mouth1f920 from "../parts/mouths/1f920.svg";
import mouth1f31a from "../parts/mouths/1f31a.svg";
import mouth1f608 from "../parts/mouths/1f608.svg";
import mouth1f921 from "../parts/mouths/1f921.svg";

import mouth1f600 from "../parts/mouths/1f600.svg";
import mouth1f602 from "../parts/mouths/1f602.svg";
import mouth1f923 from "../parts/mouths/1f923.svg";
import mouth1f601 from "../parts/mouths/1f601.svg";
import mouth1f60d from "../parts/mouths/1f60d.svg";
import mouth1f609 from "../parts/mouths/1f609.svg";
import mouth263a from "../parts/mouths/263a.svg";
import mouth1f435 from "../parts/mouths/1f435.svg";
import mouth1f638 from "../parts/mouths/1f638.svg";
import mouth1f60f from "../parts/mouths/1f60f.svg";
import mouth1f63c from "../parts/mouths/1f63c.svg";
import mouth1f47d from "../parts/mouths/1f47d.svg";
import mouth1f98d from "../parts/mouths/1f98d.svg";

import mouth1f610 from "../parts/mouths/1f610.svg";
import mouth1f614 from "../parts/mouths/1f614.svg";
import mouth1f633 from "../parts/mouths/1f633.svg";

import mouth1f624 from "../parts/mouths/1f624.svg";
import mouth1f97a from "../parts/mouths/1f97a.svg";
import mouth1f9d0 from "../parts/mouths/1f9d0.svg";

import mouth1f643 from "../parts/eyes/1f643.svg";
import mouth2639 from "../parts/mouths/2639.svg";
import mouth1f641 from "../parts/mouths/1f641.svg";
import mouth1f612 from "../parts/mouths/1f612.svg";
import mouth1f613 from "../parts/mouths/1f613.svg";
import mouth1f625 from "../parts/mouths/1f625.svg";
import mouth1f622 from "../parts/mouths/1f622.svg";
import mouth1f62a from "../parts/mouths/1f62a.svg";
import mouth1f620 from "../parts/mouths/1f620.svg";
import mouth1f623 from "../parts/mouths/1f623.svg";
import mouth1f621 from "../parts/mouths/1f621.svg";
import mouth1f63f from "../parts/mouths/1f63f.svg";
import mouth1f63e from "../parts/mouths/1f63e.svg";
import mouth1f47f from "../parts/mouths/1f47f.svg";

import mouth1f629 from "../parts/mouths/1f629.svg";
import mouth1f62b from "../parts/mouths/1f62b.svg";

import mouth1f971 from "../parts/mouths/1f971.svg";
import mouth1f92b from "../parts/mouths/1f92b.svg";
import mouth1f631 from "../parts/mouths/1f631.svg";
import mouth1f62e from "../parts/mouths/1f62e.svg";
import mouth1f635 from "../parts/mouths/1f635.svg";
import mouth1f62f from "../parts/mouths/1f62f.svg";
import mouth1f634 from "../parts/mouths/1f634.svg";
import mouth1f92f from "../parts/mouths/1f92f.svg";
import mouth1f640 from "../parts/mouths/1f640.svg";
import mouth1f62d from "../parts/mouths/1f62d.svg";
import mouth1f632 from "../parts/mouths/1f632.svg";

import mouth1f914 from "../parts/mouths/1f914.svg";
import mouth1f644 from "../parts/mouths/1f644.svg";
import mouth1f615 from "../parts/mouths/1f615.svg";
import mouth1f925 from "../parts/mouths/1f925.svg";
import mouth1f927 from "../parts/mouths/1f927.svg";

import mouth1f974 from "../parts/mouths/1f974.svg";
import mouth1f616 from "../parts/mouths/1f616.svg";
import mouth1f383 from "../parts/mouths/1f383.svg";

import mouth1f61a from "../parts/mouths/1f61a.svg";
import mouth1f618 from "../parts/mouths/1f618.svg";
import mouth1f617 from "../parts/mouths/1f617.svg";
import mouth1f63d from "../parts/mouths/1f63d.svg";

import mouth1f975 from "../parts/mouths/1f975.svg";
import mouth1f61b from "../parts/mouths/1f61b.svg";
import mouth1f60b from "../parts/mouths/1f60b.svg";
import mouth1f92a from "../parts/mouths/1f92a.svg";
import mouth1f924 from "../parts/mouths/1f924.svg";
import mouth1f913 from "../parts/mouths/1f913.svg";
import mouth1f911 from "../parts/mouths/1f911.svg";
import mouth1f92e from "../parts/mouths/1f92e.svg";

import mouth1f62c from "../parts/mouths/1f62c.svg";
import mouth1f976 from "../parts/mouths/1f976.svg";
import mouth1f910 from "../parts/mouths/1f910.svg";
import mouth1f912 from "../parts/mouths/1f912.svg";
import mouth1f922 from "../parts/mouths/1f922.svg";
import mouth1f431 from "../parts/mouths/1f431.svg";
import mouth1f437 from "../parts/mouths/1f437.svg";
import mouth1f92c from "../parts/mouths/1f92c.svg";
import mouth1f92d from "../parts/mouths/1f92d.svg";
import mouth1f973 from "../parts/mouths/1f973.svg";

// NG
// import mouth1f4a9 from '../parts/mouths/1f4a9.svg';

// duplicated
// import mouth1f619 from '../parts/mouths/1f619.svg';
// import mouth1f61c from '../parts/mouths/1f61c.svg';
// import mouth1f61d from '../parts/mouths/1f61d.svg';
// import mouth1f603 from '../parts/mouths/1f603.svg';
// import mouth1f604 from '../parts/mouths/1f604.svg';
// import mouth1f605 from '../parts/mouths/1f605.svg';
// import mouth1f606 from '../parts/mouths/1f606.svg';
// import mouth1f60c from '../parts/mouths/1f60c.svg';
// import mouth1f639 from '../parts/mouths/1f639.svg';
// import mouth1f63a from '../parts/mouths/1f63a.svg';
// import mouth1f63b from '../parts/mouths/1f63b.svg';
// import mouth1f929 from '../parts/mouths/1f929.svg';
// import mouth1f611 from '../parts/mouths/1f611.svg';
// import mouth1f61f from '../parts/mouths/1f61f.svg';
// import mouth1f626 from '../parts/mouths/1f626.svg';
// import mouth1f627 from '../parts/mouths/1f627.svg';
// import mouth1f628 from '../parts/mouths/1f628.svg';
// import mouth1f61e from '../parts/mouths/1f61e.svg';
// import mouth1f630 from '../parts/mouths/1f630.svg';
// import mouth1f915 from '../parts/mouths/1f915.svg';
// import mouth1f928 from '../parts/mouths/1f928.svg';

import texture1f428 from "../parts/textures/1f428.svg";
import texture1f383 from "../parts/textures/1f383.svg";
import textureCommonCat from "../parts/textures/common_cat.svg";
import texture1f435 from "../parts/textures/1f435.svg";
import texture1f98d from "../parts/textures/1f98d.svg";

import texture1f60a from "../parts/textures/1f60a.svg";
import texture1f61a from "../parts/textures/1f61a.svg";
import texture263a from "../parts/textures/263a.svg";
import texture1f633 from "../parts/textures/1f633.svg";
import texture1f921 from "../parts/textures/1f921.svg";

import texture1f973 from "../parts/textures/1f973.svg";

// NG
// import texture1f425 from '../parts/textures/1f425.svg';

import other1f607 from "../parts/others/1f607.svg";
import other1f921 from "../parts/others/1f921.svg";
import other1f915 from "../parts/others/1f915.svg";

import other1f913 from "../parts/others/1f913.svg";

import other1f925 from "../parts/others/1f925.svg";
import other1f927 from "../parts/others/1f927.svg";
import other1f624 from "../parts/others/1f624.svg";
import other1f637 from "../parts/others/1f637.svg";

import other1f914 from "../parts/others/1f914.svg";
import other1f971 from "../parts/others/1f971.svg";
import other1f917 from "../parts/others/1f917.svg";
import other1f92b from "../parts/others/1f92b.svg";

import other1f648 from "../parts/others/1f648.svg";
import other1f649 from "../parts/others/1f649.svg";
import other1f64a from "../parts/others/1f64a.svg";

import other1f613 from "../parts/others/1f613.svg";
import other1f605 from "../parts/others/1f605.svg";
import other1f975 from "../parts/others/1f975.svg";
import other1f625 from "../parts/others/1f625.svg";
import other1f622 from "../parts/others/1f622.svg";

import other1f923 from "../parts/others/1f923.svg";
import other1f602 from "../parts/others/1f602.svg";
import other1f639 from "../parts/others/1f639.svg";
import other1f63f from "../parts/others/1f63f.svg";

import other1f62a from "../parts/others/1f62a.svg";

import other1f618 from "../parts/others/1f618.svg";
import other1f634 from "../parts/others/1f634.svg";
import other1f970 from "../parts/others/1f970.svg";
import other1f973 from "../parts/others/1f973.svg";
import other1f976 from "../parts/others/1f976.svg";

// duplicated
// import other1f630 from '../parts/others/1f630.svg';

export const categories = [
  { value: "base", label: "ベース" },
  { value: "eyes", label: "目" },
  { value: "mouths", label: "口" },
  { value: "others", label: "飾り" },
  { value: "textures", label: "その他" },
];

export const base = [
  empty,
  baseCommon,
  base1f921,
  base1f922,
  base1f976,
  base1f975,
  base1f621,
  baseCommonCat,
  base1f435,
  base1f437,
  base1f47d,
  base1f608,
  base1f628,
  base1f631,
  base1f631Flat,
  base1f640,
  base1f920,
  base1f973,
  base1f92f,
  base1f345,
  base1f383,
  base1f4a9,
];

export const eyes = [
  empty,
  eyes1f425,
  eyes1f921,
  eyes1f600,
  eyes1f913,
  eyes1f61b,
  eyes1f617,
  eyes1f610,
  eyes1f925,
  eyes1f920,
  eyes1f92f,
  eyes1f643,
  eyes1f603,
  eyes1f31a,
  eyes1f63a,
  eyes1f435,
  eyes1f437,
  eyes1f431,
  eyes1f428,
  eyes1f917,
  eyes1f92d,
  eyes1f915,
  eyes1f604,
  eyes1f613,
  eyes1f61e,
  eyes1f970,
  eyes1f601,
  eyes1f607,
  eyes1f60a,
  eyes1f60b,
  eyes1f971,
  eyes1f637,
  eyes1f973,
  eyes1f611,
  eyes1f634,
  eyes1f927,
  eyes1f606,
  eyes1f92e,
  eyes1f923,
  eyes1f922,
  eyes1f98d,
  eyes1f383,
  eyes1f644,
  eyes1f97a,
  eyes1f4a9,
  eyes1f47d,
  eyes1f640,
  eyes1f631,
  eyes1f61c,
  eyes1f92a,
  eyes1f911,
  eyes1f60d,
  eyes1f63b,
  eyes1f929,
  eyes1f60e,
  eyes1f92b,
  eyes1f62f,
  eyes1f632,
  eyes1f627,
  eyes1f622,
  eyes1f63f,
  eyes1f924,
  eyes1f602,
  eyes1f61a,
  eyes1f638,
  eyes1f974,
  eyes1f630,
  eyes1f61f,
  eyes1f912,
  eyes1f625,
  eyes1f975,
  eyes1f976,
  eyes1f629,
  eyes1f614,
  eyes1f60c,
  eyes1f62a,
  eyes263a,
  eyes1f62b,
  eyes1f623,
  eyes1f616,
  eyes1f60f,
  eyes1f612,
  eyes1f624,
  eyes1f620,
  eyes1f63c,
  eyes1f63e,
  eyes1f92c,
  eyes1f621,
  eyes1f47f,
  eyes1f608,
  eyes1f618,
  eyes1f609,
  eyes1f928,
  eyes1f914,
  eyes1f633,
  eyes1f635,
  eyes1f62d,
  eyes1f9d0,
];

export const mouths = [
  empty,
  mouth1f917,
  mouth1f970,
  mouth1f60a,
  mouth1f607,
  mouth1f60e,
  mouth1f642,
  mouth1f920,
  mouth1f31a,
  mouth1f608,
  mouth1f921,
  mouth1f600,
  mouth1f602,
  mouth1f923,
  mouth1f601,
  mouth1f60d,
  mouth1f609,
  mouth263a,
  mouth1f435,
  mouth1f638,
  mouth1f60f,
  mouth1f63c,
  mouth1f47d,
  mouth1f98d,
  mouth1f610,
  mouth1f614,
  mouth1f633,
  mouth1f624,
  mouth1f97a,
  mouth1f9d0,
  mouth1f643,
  mouth2639,
  mouth1f641,
  mouth1f612,
  mouth1f613,
  mouth1f625,
  mouth1f622,
  mouth1f62a,
  mouth1f620,
  mouth1f623,
  mouth1f621,
  mouth1f63f,
  mouth1f63e,
  mouth1f47f,
  mouth1f629,
  mouth1f62b,
  mouth1f971,
  mouth1f92b,
  mouth1f631,
  mouth1f62e,
  mouth1f635,
  mouth1f62f,
  mouth1f634,
  mouth1f92f,
  mouth1f640,
  mouth1f62d,
  mouth1f632,
  mouth1f914,
  mouth1f644,
  mouth1f615,
  mouth1f925,
  mouth1f927,
  mouth1f974,
  mouth1f616,
  mouth1f383,
  mouth1f61a,
  mouth1f618,
  mouth1f617,
  mouth1f63d,
  mouth1f975,
  mouth1f61b,
  mouth1f60b,
  mouth1f92a,
  mouth1f924,
  mouth1f913,
  mouth1f911,
  mouth1f92e,
  mouth1f62c,
  mouth1f976,
  mouth1f910,
  mouth1f912,
  mouth1f922,
  mouth1f431,
  mouth1f437,
  mouth1f92c,
  mouth1f92d,
  mouth1f973,
];

export const textures = [
  empty,
  texture1f428,
  texture1f383,
  textureCommonCat,
  texture1f435,
  texture1f98d,
  texture1f60a,
  texture1f61a,
  texture263a,
  texture1f633,
  texture1f921,
  texture1f973,
];

export const others = [
  empty,
  other1f607,
  other1f921,
  other1f915,
  other1f913,
  other1f925,
  other1f927,
  other1f624,
  other1f637,
  other1f914,
  other1f971,
  other1f917,
  other1f92b,
  other1f648,
  other1f649,
  other1f64a,
  other1f613,
  other1f605,
  other1f975,
  other1f625,
  other1f622,
  other1f923,
  other1f602,
  other1f639,
  other1f63f,
  other1f62a,
  other1f618,
  other1f634,
  other1f970,
  other1f973,
  other1f976,
];
